export const ItemTemplate = ({ optionObj }) => {
  return (
    <div>
      {optionObj.label}{" "}
      <span>
        (typ pola: <span>{optionObj.type}</span>)
      </span>
    </div>
  );
};
